export default __webpack_public_path__ + "static/media/wsb-favicon.bdc5a0b0.ico";